import { 
    INFORM_SET
        } from "./actionTypes"


const initialState = {
    error:"",
    status: false,
}




 const InformReducer = (state = initialState,action) => {

  switch (action.type) {

        case INFORM_SET:
          return {
            ...state,
            action
          };
   
      default:
        return { ...state };
  }


}


export default InformReducer;        